var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"item"},_vm._l((_vm.columns),function(item){return _c(item.component,{key:item.id,tag:"component",style:({ 'min-height': '70px' }),attrs:{"data":_vm.data[item.id],"record":_vm.data,"classSuffix":item.classSuffix}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }